// @ts-expect-error no types
import ViewApp from './App';
new ViewApp().start();